import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    rawMaterialVendors: [],
    total: 0,
    page: 1,
    pages: 1,
    isLoading: false
};

const rawMaterialVendorSlice = createSlice({
    name: "rawMaterialVendor",
    initialState,
    reducers: {
        setRawMaterialVendors: (state, action) => {
            state.rawMaterialVendors = action.payload.data;
            state.total = action.payload.total;
            state.page = action.payload.page;
            state.pages = action.payload.pages;
        },
        addRawMaterialVendor: (state, action) => {
            state.rawMaterialVendors.unshift(action.payload);
        },
        updateRawMaterialVendor: (state, action) => {
            const index = state.rawMaterialVendors.findIndex(
                (item) => item._id === action.payload._id
            );
            if (index !== -1) {
                state.rawMaterialVendors[index] = action.payload;
            }
        },
        deleteRawMaterialVendor: (state, action) => {
            state.rawMaterialVendors = state.rawMaterialVendors.filter(
                (item) => item._id !== action.payload
            );
        },
        setLoading: (state, action) => {
            state.isLoading = action.payload;
        },
    }
});

export const {
    setRawMaterialVendors,
    addRawMaterialVendor,
    updateRawMaterialVendor,
    deleteRawMaterialVendor,
    setLoading
} = rawMaterialVendorSlice.actions;

export const RawMaterialVendorReducer = rawMaterialVendorSlice.reducer;